// extracted by mini-css-extract-plugin
export default {"rangeFields":"Price_rangeFields__r86DE","rangeField":"Price_rangeField__pdVtH","dashMark":"Price_dashMark__4tvy6"};